import { MAX_PLAYERS as FREECELL_MAX_PLAYERS, MIN_PLAYERS as FREECELL_MIN_PLAYERS } from './freecell/rules.js';
import { MAX_PLAYERS as MINESWEEPER_MAX_PLAYERS, MIN_PLAYERS as MINESWEEPER_MIN_PLAYERS, } from './minesweeper/rules.js';
import { MAX_PLAYERS as NOUGHTS_MAX_PLAYERS, MIN_PLAYERS as NOUGHTS_MIN_PLAYERS } from './noughts/rules.js';
import { MAX_PLAYERS as SOLITAIRE_MAX_PLAYERS, MIN_PLAYERS as SOLITAIRE_MIN_PLAYERS } from './solitaire/rules.js';
import { MAX_PLAYERS as SPIDER_MAX_PLAYERS, MIN_PLAYERS as SPIDER_MIN_PLAYERS } from './spider/rules.js';
import { MAX_PLAYERS, MIN_PLAYERS } from './switch/rules.js';
export const GAMES = [
    {
        id: 'switch',
        name: 'Switch',
        blurb: 'Shed your hand first. Mind the twos.',
        description: 'The British shedding game, cousin to Crazy Eights. Match the top card by suit or rank, ' +
            'use the power cards to skip, reverse and pile pick-ups on whoever is next, and call ' +
            '"last card" before anyone catches you keeping quiet.',
        minPlayers: MIN_PLAYERS,
        maxPlayers: MAX_PLAYERS,
        kind: 'cards',
        status: 'available',
        href: '/switch',
    },
    {
        id: 'solitaire',
        name: 'Solitaire',
        blurb: 'Klondike, on your own, whenever.',
        description: 'The patience game everyone already knows. Build the four foundations up from the Aces and the ' +
            'seven columns down in alternating colours, turning the stock one card at a time — or three, ' +
            'if you want the version that actually puts up a fight.',
        minPlayers: SOLITAIRE_MIN_PLAYERS,
        maxPlayers: SOLITAIRE_MAX_PLAYERS,
        kind: 'cards',
        status: 'available',
        href: '/solitaire',
    },
    {
        id: 'freecell',
        name: 'FreeCell',
        blurb: 'Every card face up. No excuses.',
        description: 'The patience game with nothing hidden and no luck left in it. All fifty-two cards are dealt ' +
            'face up across eight columns, and four cells beside the foundations hold one card each while ' +
            'you dig. Almost every deal can be solved — which means when one is not, it was you.',
        minPlayers: FREECELL_MIN_PLAYERS,
        maxPlayers: FREECELL_MAX_PLAYERS,
        kind: 'cards',
        status: 'available',
        beta: true,
        href: '/freecell',
    },
    {
        id: 'spider',
        name: 'Spider',
        blurb: 'Two packs. Eight runs. One suit, or four.',
        description: 'Patience at its most patient. Two packs are dealt across ten columns, and you build eight ' +
            'King-to-Ace runs to clear them off. Cards stack by rank whatever their suit — but only a run ' +
            'in one suit will move as a piece, which is the whole game. Choose one suit, two, or all four.',
        minPlayers: SPIDER_MIN_PLAYERS,
        maxPlayers: SPIDER_MAX_PLAYERS,
        kind: 'cards',
        status: 'available',
        beta: true,
        href: '/spider',
    },
    {
        id: 'noughts-and-crosses',
        name: 'Noughts and Crosses',
        blurb: 'Nine squares. Nowhere to hide.',
        description: 'The one off the back of every exercise book, against a friend or an AI that already knows how ' +
            'it ends. Played straight it is a draw between two people paying attention, so the interest is ' +
            'in what you change: a wider grid where three in a row is suddenly hard to stop, or the version ' +
            'where making a line is how you lose.',
        minPlayers: NOUGHTS_MIN_PLAYERS,
        maxPlayers: NOUGHTS_MAX_PLAYERS,
        kind: 'paper',
        status: 'available',
        beta: true,
        href: '/noughts-and-crosses',
    },
    {
        id: 'minesweeper',
        name: 'Minesweeper',
        blurb: 'Every number is telling you something.',
        description: 'Not a guessing game, whatever the first click suggests. Every number you open says exactly how ' +
            'many mines are touching it, and almost the whole board can be worked out from those numbers ' +
            'alone — the skill is in reading two of them together. Beginner, intermediate, or the full ' +
            'thirty-by-sixteen with ninety-nine mines in it.',
        minPlayers: MINESWEEPER_MIN_PLAYERS,
        maxPlayers: MINESWEEPER_MAX_PLAYERS,
        kind: 'arcade',
        status: 'available',
        beta: true,
        href: '/minesweeper',
    },
    {
        id: 'last-line',
        name: 'Last Line',
        blurb: 'Six cities. Three batteries. Ten shots each.',
        description: 'Everything falling out of the sky is aimed at something you are supposed to be protecting, and ' +
            'you have three batteries of ten to stop it with. You do not shoot the bombs; you shoot the air ' +
            'they are going to be in. Ammunition is the real enemy — the wave you lose is usually the one ' +
            'where you fired twice at something one shot would have caught.',
        minPlayers: 1,
        maxPlayers: 1,
        kind: 'arcade',
        status: 'available',
        beta: true,
        scoring: { metric: 'points', direction: 'desc', detail: ['wave'] },
        href: '/last-line',
    },
    {
        id: 'circuit',
        name: 'Circuit',
        blurb: 'Clear the nodes. The sentries are watching.',
        description: 'A maze, a trail of nodes to collect, and four sentries with opinions about where you are going. ' +
            'They hunt in formation and then, briefly, they scatter — and a surge turns the tables for as ' +
            'long as it lasts. Learning the board is half of it; learning when the sentries stop chasing is ' +
            'the other half.',
        minPlayers: 1,
        maxPlayers: 1,
        kind: 'arcade',
        status: 'available',
        beta: true,
        scoring: { metric: 'points', direction: 'desc', detail: ['wave'] },
        href: '/circuit',
    },
    {
        id: 'shard',
        name: 'Shard',
        blurb: 'Break the rocks. Mind the saucers.',
        description: 'Drifting rock, and a ship with no brakes — only thrust, and whichever way you were already ' +
            'going. Every rock you hit becomes two smaller, faster ones, so a cleared screen is something ' +
            'you have to plan rather than blunder into. The saucers turn up when you are least able to ' +
            'spare the attention.',
        minPlayers: 1,
        maxPlayers: 1,
        kind: 'arcade',
        status: 'available',
        beta: true,
        scoring: { metric: 'points', direction: 'desc', detail: ['wave'] },
        href: '/shard',
    },
    {
        id: 'stack',
        name: 'Stack',
        blurb: 'Seven shapes. Ten columns. No gaps.',
        description: 'Seven shapes fall into a well ten columns wide, and a row with no gaps left in it disappears. ' +
            'You are not playing to survive — the well fills up whichever way you play it — you are playing ' +
            'to be tidy about it, because four rows taken at once are worth eight times four rows taken one ' +
            'at a time. The shape you want is always the one after next.',
        minPlayers: 1,
        maxPlayers: 1,
        kind: 'arcade',
        status: 'available',
        beta: true,
        scoring: { metric: 'points', direction: 'desc', detail: ['wave'] },
        href: '/stack',
    },
    {
        id: 'descent',
        name: 'Descent',
        blurb: 'Gravity is patient. Your fuel is not.',
        description: 'A lander, a rock with no air on it, and a motor that only points one way. There are no ' +
            'brakes — every bit of speed you lose costs fuel you wanted for later, and the ground is ' +
            'coming up whether you have any left or not. Three pads on every level: a wide one to get ' +
            'down on, and a narrow one worth more for trying.',
        minPlayers: 1,
        maxPlayers: 1,
        kind: 'arcade',
        status: 'available',
        beta: true,
        scoring: { metric: 'points', direction: 'desc', detail: ['wave'] },
        href: '/descent',
    },
];
export function findGame(id) {
    return GAMES.find((game) => game.id === id);
}
export const PLAYABLE_GAMES = GAMES.filter((g) => g.status === 'available');
//# sourceMappingURL=games.js.map